import React, { useEffect } from 'react';
import Heading from '@codedrop/typography/esm/heading';

const Modal = ({
  className,
  buttonText,
  title,
  children,
  modalState,
  setModalState,
  id
}) => {
  useEffect(() => {
    document.body.classList.toggle('no-scroll', modalState);
  }, [modalState]);

  const handleClick = () => {
    setModalState(!modalState);
  };

  const handleKeydown = e => {
    switch (e.code) {
      case 'Escape':
        setModalState(false);
        break;

      default:
        break;
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button--primary",
    onClick: handleClick,
    "aria-controls": id,
    "aria-expanded": modalState
  }, buttonText), /*#__PURE__*/React.createElement("div", {
    className: "modal ".concat(modalState ? 'modal--show' : ''),
    id: id,
    "aria-hidden": !modalState,
    onKeyDown: handleKeydown
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal__inner"
  }, /*#__PURE__*/React.createElement("button", {
    className: "modal__close icon icon--close",
    onClick: handleClick
  }, "Close"), /*#__PURE__*/React.createElement("div", {
    className: "text--centered"
  }, title ? /*#__PURE__*/React.createElement(Heading, {
    tag: "h3",
    headingClass: "modal__heading heading--l text--centered"
  }, title) : '', children))));
};

Modal.displayName = 'Modal';
Modal.defaultProps = {
  className: '',
  buttonText: 'Open',
  title: false,
  modalState: false,
  id: 'modal',
  setModalState: () => {}
};
export default Modal;